export default __webpack_public_path__ + "static/media/KZ.T.06.Е1246 black.63d53ec3.svg";